export const roles = {
  ADMIN: "ADMIN",
  REVIEWER: "REVIEWER",
  AUDITOR: "AUDITOR",
  LEADERSHIP: "LEADERSHIP",
  "PROJECT MANAGER": "PROJECT MANAGER",
};

export const permissions = {
  [roles.ADMIN]: ["dashboard","case-study", "question", "leadership", "access", "faq"],
  [roles.REVIEWER]: ["dashboard","case-study", "faq"],
  [roles.AUDITOR]: ["dashboard","case-study", "faq"],
  [roles.LEADERSHIP]: ["dashboard", "leadership","case-study", "faq"],
  [roles["PROJECT MANAGER"]]: ["dashboard","case-study", "faq"],
};
